<template>
  <div v-if="comType == 'UI'">
    <div
      :style="{
        'border-radius': `${radius}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        'background-color': backgroundColor,
      }"
      v-if="styleMode == 1"
    >
      <div class="shop-content">
        <section>
          <h3><i class="el-icon-location"></i>温州滨江万象城店</h3>
          <h4>
            距您99.9km<span
              >&nbsp;|&nbsp;鹿城区滨江街道瓯江路3999号温州滨江华润万象城F2</span
            >
          </h4>
        </section>
        <section>
          <p>去下单<i class="el-icon-arrow-right"></i></p>
        </section>
      </div>
    </div>
    <div v-else-if="styleMode == 2" class="shop-icon">
      <h3>温州滨江万象城店<i class="el-icon-arrow-right"></i></h3>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="样式">
          <el-radio-group v-model="styleModeValue" size="small">
            <el-radio-button :label="1">样式1</el-radio-button>
            <el-radio-button :label="2">样式2</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-show="styleModeValue == 1">
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <div>
          <el-form-item label="圆角">
            <div class="slider-block">
              <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
              <div class="set-radius">
                <el-popover placement="top" width="160" trigger="hover">
                  <radiusBox :radius="radiusValue"></radiusBox>
                  <el-button slot="reference">可见性</el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上间距">
            <div class="slider-block">
              <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下间距">
            <div class="slider-block">
              <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左间距">
            <div class="slider-block">
              <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右间距">
            <div class="slider-block">
              <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="上内间距">
            <div class="slider-block">
              <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下内间距">
            <div class="slider-block">
              <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左内间距">
            <div class="slider-block">
              <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右内间距">
            <div class="slider-block">
              <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import radiusBox from "@/components/appltDecoration/radiusBox";
import { comMixins } from "@/mixins/comMixins";
export default {
  mixins: [comMixins],
  name: "comShopInfo",
  components: {
    radiusBox,
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    styleMode: {
      type: Number,
      default: 1,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 10,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 10,
    },
    paddingTop: {
      type: Number,
      default: 10,
    },
    paddingRight: {
      type: Number,
      default: 10,
    },
    paddingBottom: {
      type: Number,
      default: 10,
    },
    paddingLeft: {
      type: Number,
      default: 10,
    },
    backgroundColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    radius: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    styleModeValue: {
      get() {
        return this.styleMode;
      },
      set(val) {
        this.$emit(`update:styleMode`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
};
</script>

<style scoped lang="less">
.shop-content {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
}

.shop-content > section:first-child {
  flex: 1;
  min-width: 200px;
  max-width: 280px;
}

.shop-content > section:first-child h3 {
  font-size: 14px;
}

.shop-content > section:first-child h4 {
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shop-content > section:first-child h4 span {
  color: #999;
}

.shop-content > section:nth-child(2) {
  color: #666;
  min-width: 70px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.shop-icon {
  position: absolute;
  z-index: 5;
  left: 10px;
  top: 10px;
  line-height: 20px;
  font-size: 14px;
  border-radius: 20px;
  padding: 5px 10px;
  color: #999;
  background-color: hsla(0, 0%, 100%, 0.8);
}
</style>
